import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications, markAsRead } from '../store/slices/notificationSlice';

function Notifications() {
  const dispatch = useDispatch();
  const { notifications, pagination, isLoading } = useSelector((state) => state.notifications);
  
  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  // Polling for real-time notifications
  useEffect(() => {
    const pollNotifications = setInterval(() => {
      dispatch(getNotifications());
    }, 15000); // 15 seconds

    return () => {
      clearInterval(pollNotifications);
    };
  }, [dispatch]);
  
  const handleRead = (id) => {
    dispatch(markAsRead(id));
  };
  
  return (
    <div className="notifications-page">
      <h1>Notifications</h1>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="notifications-list">
          {notifications.length === 0 ? (
            <p>No notifications</p>
          ) : (
            notifications.map((notification) => (
              <div 
                key={notification._id} 
                className={`notification-item ${notification.status === 'delivered' ? 'read' : 'unread'}`}
                onClick={() => notification.status !== 'delivered' && handleRead(notification._id)}
              >
                <h3>{notification.subject || notification.channel}</h3>
                <p>{notification.message}</p>
                <span className="notification-time">
                  {new Date(notification.createdAt).toLocaleString()}
                </span>
              </div>
            ))
          )}
        </div>
      )}
      
      {pagination.pages > 1 && (
        <div className="pagination">
          {Array.from({ length: pagination.pages }, (_, i) => (
            <button key={i + 1} onClick={() => dispatch(getNotifications({ page: i + 1 }))}>
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Notifications;